import styled from "styled-components";

export const DatesCalendarContainer = styled.div`
    grid-column-start: 1;
    grid-column-end: 7;
    grid-row-start: 3;
    grid-row-end: 12;
    
    @media (max-width: 800px) {
        grid-column-start: 1;
        grid-column-end: 9;
    }
`;
export const Calendar = styled.table`
    width: 100%;
    table-layout: fixed;
    border-spacing: 1vw;
    border-collapse: separate;
    background-color: var(--main-light-grey-color);
`;
export const HeaderBlock = styled.td`
    font-family: Poppins-Regular;
    text-align: center;
    vertical-align: middle;
`;
export const SummaryWrapper = styled.div`
    grid-column-start: 7;
    grid-column-end: 9;
    grid-row-start: 3;
    grid-row-end: 12;
    @media (max-width: 800px) {
        grid-column-start: 1;
        grid-column-end: 9;
        grid-row-start: 12;
        grid-row-end: 21;
    }
`;
export const AvailabilityContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: 0 1em 3em 1em;
    @media (min-width: 500px) {
        padding: 0 3em 8em 3em;
    }
    @media (min-width: 870px) {
        padding: 0 8em 8em 8em;
    }
    @media (min-width: 1220px) {
        padding: 0 12em 8em 12em;
    }
    @media (min-width: 1600px) {
        padding: 0 18em 8em 18em;
    }
`;
export const FullCalenderContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: repeat(9, 5vw);
    grid-gap: 10px;
    width: 100%;
`;
export const HeaderContainer = styled.div`
    grid-column-start: 1;
    grid-column-end: 7;
    grid-row-start: 1;
    grid-row-end: 3;
    display:flex;
    justify-content:center;
    align-items:center;
    @media (max-width: 800px) {
        grid-column-start: 1;
        grid-column-end: 9;
    }
`;
export const CalendarHeader = styled.div`
    text-align:center;
    background: var(--main-orange-color);
    clip-path: polygon(0 0, 100% 0, 100% 40%, 50% 100%, 0 40%);
    width:640px;
    font-family: Lato-Bold;
    height:60px;
    padding:12px;
    color:#ffff;
    font-size: 1.1em;
    @media (min-width: 800px) {
        font-size: 1.8em;
        height:80px;
    }
`;
